<a (click)="openHistoryModal()">History</a>
